import Terminal from "../../utilities/data/model/Terminal";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { TerminalModelContext } from "../../utilities/terminal";

const getObservables = ({ terminal }: { terminal: Terminal }) => ({
  terminal: terminal.observe(),
});

export interface WatchedTerminalProviderRendererProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  children?: React.ReactNode;
}

const WatchedTerminalProviderRenderer = ({
  terminal,
  children,
}: WatchedTerminalProviderRendererProps) => {
  return (
    <TerminalModelContext.Provider value={{ terminal: terminal }}>
      {children}
    </TerminalModelContext.Provider>
  );
};

const enhance = withObservables(["terminal"], getObservables);

export const WatchedTerminalProvider = enhance(WatchedTerminalProviderRenderer);
